import compuedFun from '../../../computed/'
import { parseTime } from '@/utils/util'
const { showName } = compuedFun()

export const searchForm = {
  name: '',
  state: undefined,
  line_id: undefined,
  template_type: undefined,
  field_name: undefined
}

export const columns = [
  {
    title: '序号',
    dataIndex: 'id',
    width: 100,
    align: 'center'
  },
  {
    title: '发布平台',
    dataIndex: 'org',
    align: 'left',
    width: 300,
    // scopedSlots: { customRender: 'org' }
  },
  {
    title: '模板类型',
    dataIndex: 'template_type',
    align: 'left',
    width: 120,
    customRender(text) {
      return showName('TEMPLATE_TYPE', text)
    }
  },
  {
    title: '模板名称',
    dataIndex: 'name',
    width: 375,
    align: 'left'
  },
  {
    title: '状态',
    dataIndex: 'state',
    align: 'left',
    width: 120,
    scopedSlots: { customRender: 'state' }
  },
  {
    title: '编辑日期',
    dataIndex: 'updated_at',
    align: 'left',
    width: 185,
    customRender(text) {
      return parseTime(text)
    }
  },
  {
    title: '操作',
    dataIndex: 'operator',
    align: 'center',
    width: 200,
    scopedSlots: { customRender: 'operator' }
  }
]
